import styled from "styled-components"
import Moment from "react-moment"
import {
  ArticleWrapperStyles,
  BottomWrapperStyles,
  CategoryStyles,
  ContentStyles,
  ContentWrapperStyles,
  DateStyles,
  ExcerptStyles,
  SocialStyles,
  ThumbStyles,
  TopWrapperStyles,
} from "./article-preview-styles"
import { Link } from "gatsby"
import { BreakPoints, media } from "../../helpers/rwd"

export const ArticleWrapper = styled.article`
  display: flex;
  align-items: flex-start;
  margin: 30px;
  &.vertical {
    flex-direction: column;
    margin: 0 30px;
    .bottom-date {
      display: none;
    }
  }
  &.horizontal {
    .top-date {
      display: none;
    }
    ${media.max(BreakPoints.phone)} {
      .top-date {
        display: inline;
      }
      .bottom-date {
        display: none;
      }
    }
  }
  ${media.max(BreakPoints.phone)} {
    flex-direction: column;
  }
  ${ArticleWrapperStyles}
`

export const Thumb = styled(Link)`
  max-width: 420px;
  height: auto;
  &.horizontal {
    width: 45%;
    ${media.max(BreakPoints.phone)} {
      width: 100%;
    }
  }
  ${ThumbStyles}
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 0 35px;
  &.vertical {
    padding: 10px 0;
  }
  ${media.max(BreakPoints.phone)} {
    padding: 10px 0 0 0;
  }
  ${ContentWrapperStyles}
`
export const Category = styled.span`
  ${CategoryStyles}
`

export const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${TopWrapperStyles}
`

export const Content = styled(Link)`
  flex: 1;
  ${ContentStyles}
`

export const Excerpt = styled.p`
  margin: 15px 0;
  ${media.max(BreakPoints.tablet)} {
    display: none;
  }
  ${ExcerptStyles}
`

export const BottomWrapper = styled.div`
  ${BottomWrapperStyles}
`

export const Date = styled(Moment)`
  ${DateStyles}
`

export const Social = styled.div`
  ${SocialStyles}
`
